import ServiceAxios from "../serviceAxios";
import {diccionary} from "./diccionary";

const API = diccionary;

export default class digitalOnboardingService {

    getDocument(uiid, numberFlow, headers){
        return new ServiceAxios().executeService(
            API.digitalOnboarding.consultFiles.url + "/" + uiid + "/" + numberFlow,
            API.digitalOnboarding.consultFiles.method,
            "",
            {},
            headers
        );
    };

    sendExceptionNobarium(uidd, headers){
        return new ServiceAxios().executeService(
            API.digitalOnboarding.exceptions.url + "/" + uidd,
            API.digitalOnboarding.exceptions.method,
            "",
            {},
            headers
        );
    }

}